"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3,9.8a.42.42,0,0,1-.42-.42A5.22,5.22,0,0,1,7.84,4.16a.42.42,0,1,1,0,.84A4.38,4.38,0,0,0,3.46,9.38.42.42,0,0,1,3,9.8Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.42,9.8A.42.42,0,0,1,0,9.38,7.85,7.85,0,0,1,7.84,1.54a.42.42,0,1,1,0,.84,7,7,0,0,0-7,7A.42.42,0,0,1,.42,9.8Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.88,9.8a.41.41,0,0,1-.41-.42A4.39,4.39,0,0,0,13.08,5a.42.42,0,0,1,0-.84A5.22,5.22,0,0,1,18.3,9.38.42.42,0,0,1,17.88,9.8Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.5,9.8a.42.42,0,0,1-.42-.42,7,7,0,0,0-7-7,.42.42,0,0,1,0-.84,7.85,7.85,0,0,1,7.84,7.84A.42.42,0,0,1,20.5,9.8Z",
    fill: "#004864"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.62,21.2h0l.87-1.42,3.09-5.23.79-1.38A6.08,6.08,0,0,0,13.05,9.1a2.61,2.61,0,0,0-5.18,0,6.07,6.07,0,0,0-3.5,5.52v3.93A1.34,1.34,0,0,1,3,19.88a.42.42,0,1,0,0,.83h5.3a2.16,2.16,0,0,0,2.12,1.75,2.08,2.08,0,0,0,.9-.2A1.92,1.92,0,0,1,11.62,21.2Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.94,21.91l-4-6.61-1.24-2.13a.35.35,0,0,0-.31-.18.38.38,0,0,0-.31.18l-1.2,2.11-3.11,5.25L12.87,22a.33.33,0,0,0,0,.36.32.32,0,0,0,.31.14H23.64a.37.37,0,0,0,.32-.18A.38.38,0,0,0,23.94,21.91Zm-6.1-6a.57.57,0,0,1,.59-.52.56.56,0,0,1,.58.52V18.8a.55.55,0,0,1-.58.52.56.56,0,0,1-.59-.52Zm.59,5.77a.69.69,0,1,1,.69-.69A.69.69,0,0,1,18.43,21.66Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;